import { changePage, changeSearchText } from './actions/query';

const queryParams = {
  searchText: {
    action: changeSearchText,
    defaultValue: '',
    selector: state => state.query.searchText || ''
  },
  page: {
    action: changePage,
    defaultValue: 1,
    selector: state => state.query.page,
    stringToValue: value => Number(value) || 1
  }
};

export default queryParams;
